<template>
  <div>
    <v-row
      class="my-6"
      justify="center"
      align="center"
    >
      <v-col cols="12" class="text-center">
        <v-btn-toggle v-model="icon">
          <v-btn
            text
            value="column"
            @click="tableView = false"
          >
            <span>Spaltenform</span>
            <v-icon>mdi-view-module</v-icon>
          </v-btn>
          <v-btn
            text
            value="table"
            @click="tableView = true"
          >
            <span>Tabllenform</span>
            <v-icon>mdi-table-large</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row
      v-if="tableView"
      align="center"
      justify="center"
      align-content="center"
      class="my-4"
    >
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>
            <span v-if="!newPlayer">Deine Spieler:</span>
            <span v-else>Neue Spieler</span>
            <div class="flex-grow-1" />
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            />
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="players"
            :search="search"
            disable-pagination
            :items-per-page="13"
            hide-default-footer
            class="elevation-1"
          >
            <template v-if="newPlayer" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td>{{ item.alter }}</td>
                  <td>{{ item.gehalt | currency }}</td>
                  <td>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-avatar
                          :color="item.position | positionColorString('color')"
                          size="28"
                          class="mr-2"
                          dark
                          v-on="on"
                        >
                          <span class="white--text title">{{ item.position }}</span>
                        </v-avatar>
                      </template>
                      <span>{{ item.position | positionColorString('string') }}</span>
                    </v-tooltip>
                  </td>
                  <td>{{ item.heimIndex }} ({{ item.heimIndex_max }})</td>
                  <td>{{ item.auswIndex }} ({{ item.auswIndex_max }})</td>
                  <td>
                    {{ item.kraft }}%<br>
                    <v-progress-linear
                      :value="item.kraft"
                      :color="item.kraft | getStatusColor"
                      height="5"
                    />
                  </td>
                  <td>
                    {{ item.motivation }}%<br>
                    <v-progress-linear
                      :value="item.motivation"
                      :color="item.motivation | getStatusColor"
                      height="5"
                    />
                  </td>
                  <td>
                    {{ item.technik }}%<br>
                    <v-progress-linear
                      :value="item.technik"
                      :color="item.technik | getStatusColor"
                      height="5"
                    />
                  </td>
                  <td>
                    {{ item.kondition }}%<br>
                    <v-progress-linear
                      :value="item.kondition"
                      :color="item.kondition | getStatusColor"
                      height="5"
                    />
                  </td>
                  <td>
                    {{ Math.ceil(item.gehalt * $store.state.teamStore.playerBuyMultiplikator) | currency }}
                  </td>
                  <td>
                    <v-btn
                      :loading="$store.state.loading"
                      :disabled="$store.state.loading"
                      color="primary"
                      dark
                      @click.native="byPlayer(item)"
                      small
                      outlined
                    >
                      Spieler kaufen
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>

            <template v-slot:item.gehalt="{ item }">
              {{ item.gehalt | currency }}
            </template>

            <template v-if="!newPlayer" v-slot:item.vertrag="{ item }">
              {{ item.vertrag }} Spieltage
              <div v-if="item.vertrag < 15 && withContract">
                <v-btn
                  :loading="$store.state.loading"
                  :disabled="$store.state.loading"
                  color="primary"
                  @click.native="extendContract(item)"
                  small
                >
                  verlängern
                  <v-icon right dark>
                    mdi-file-plus
                  </v-icon>
                </v-btn>
              </div>

              <div v-if="withContract">
                <v-btn
                  :loading="$store.state.loading"
                  :disabled="$store.state.loading"
                  color="red"
                  dark
                  @click.native="terminateContract(item)"
                  small
                >
                  auflösen
                  <v-icon right dark>
                    mdi-delete-forever
                  </v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:item.position="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-avatar
                    :color="item.position | positionColorString('color')"
                    size="28"
                    class="mr-2"
                    dark
                    v-on="on"
                  >
                    <span class="white--text title">{{ item.position }}</span>
                  </v-avatar>
                </template>
                <span>{{ item.position | positionColorString('string') }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.kraft="{ item }">
              {{ item.kraft }}%<br>
              <v-progress-linear
                :value="item.kraft"
                :color="item.kraft | getStatusColor"
                height="5"
              />
            </template>
            <template v-slot:item.motivation="{ item }">
              {{ item.motivation }}%<br>
              <v-progress-linear
                :value="item.motivation"
                :color="item.motivation | getStatusColor"
                height="5"
              />
            </template>
            <template v-slot:item.technik="{ item }">
              {{ item.technik }}%<br>
              <v-progress-linear
                :value="item.technik"
                :color="item.technik | getStatusColor"
                height="5"
              />
            </template>
            <template v-slot:item.kondition="{ item }">
              {{ item.kondition }}%<br>
              <v-progress-linear
                :value="item.kondition"
                :color="item.kondition | getStatusColor"
                height="5"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-data-iterator
      v-else
      :items="players"
      disable-pagination
      :items-per-page="13"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
          class="mb-2"
          color="primary darken-2"
          dark
          flat
        >
          <v-toolbar-title v-if="newPlayer">
            Neue Spieler:
          </v-toolbar-title>
          <v-toolbar-title v-else>
            Deine Spieler:
          </v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.name"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card>
              <v-card-title class="title">
                <v-row>
                  <v-col cols="2">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-avatar
                          :color="item.position | positionColorString('color')"
                          size="32"
                          class="mr-2"
                          dark
                          v-on="on"
                        >
                          <span class="white--text title">{{ item.position }}</span>
                        </v-avatar>
                      </template>
                      <span>{{ item.position | positionColorString('string') }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col>
                    {{ item.name }}
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col cols="6" class="subtitle-2">
                    Alter:
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.alter }}
                  </v-col>

                  <v-col cols="6" class="subtitle-2">
                    Gehalt:
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.gehalt | currency }}
                  </v-col>
                </v-row>
                <v-row
                  v-if="!newPlayer"
                  justify="center"
                  align="center"
                >
                  <v-col cols="6" class="subtitle-2">
                    Vertrag noch:
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.vertrag }} Spieltage
                  </v-col>
                </v-row>

                <v-row
                  v-if="withContract && !newPlayer"
                  align="center"
                  justify="center"
                >
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                  <v-col cols="12" class="text-center title py-1">
                    Vertrag
                  </v-col>
                  <v-col cols="12" sm="6" class="text-center">
                    <v-btn
                      :loading="$store.state.loading"
                      :disabled="$store.state.loading"
                      color="red"
                      dark
                      @click.native="terminateContract(item)"
                      small
                      tile
                      outlined
                    >
                      <v-icon
                        left
                        dark
                        class="mr-1"
                      >
                        mdi-delete-forever
                      </v-icon>
                      auflösen
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-center">
                    <v-btn
                      v-if="item.vertrag < 15"
                      :loading="$store.state.loading"
                      :disabled="$store.state.loading"
                      color="primary"
                      @click.native="extendContract(item)"
                      small
                      tile
                      outlined
                    >
                      <v-icon
                        left
                        dark
                        class="mr-1"
                      >
                        mdi-file-plus
                      </v-icon>
                      verlängern
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col cols="6" class="subtitle-2">
                    HeimIndex (max):
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.heimIndex }} ({{ item.heimIndex_max }})
                  </v-col>
                  <v-col cols="6" class="subtitle-2">
                    AuswIndex (max):
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.auswIndex }} ({{ item.auswIndex_max }})
                  </v-col>
                </v-row>

                <v-row
                  v-if="!newPlayer"
                  align="center"
                  justify="center"
                >
                  <v-col cols="6" class="subtitle-2">
                    Bestleistungen:
                  </v-col>
                  <v-col cols="6" class="body-2 font-weight-black">
                    {{ item.heimBestleistung.ergebnis || 0 }} (H) / {{ item.auswBestleistung.ergebnis || 0 }} (A)
                  </v-col>
                </v-row>

                <v-row justify="center" align="center">
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col class="subtitle-2">
                    Kraft:
                  </v-col>
                  <v-col>
                    <v-progress-linear
                      :value="item.kraft"
                      :color="item.kraft | getStatusColor"
                      height="8"
                    />
                  </v-col>
                  <v-col class="body-2 font-weight-black">
                    {{ item.kraft }}%
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col class="subtitle-2">
                    Motivation:
                  </v-col>
                  <v-col>
                    <v-progress-linear
                      :value="item.motivation"
                      :color="item.motivation | getStatusColor"
                      height="8"
                    />
                  </v-col>
                  <v-col class="body-2 font-weight-black">
                    {{ item.motivation }}%
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col class="subtitle-2">
                    Technik:
                  </v-col>
                  <v-col>
                    <v-progress-linear
                      :value="item.technik"
                      :color="item.technik | getStatusColor"
                      height="8"
                    />
                  </v-col>
                  <v-col class="body-2 font-weight-black">
                    {{ item.technik }}%
                  </v-col>
                </v-row>

                <v-row
                  justify="center"
                  align="center"
                >
                  <v-col class="subtitle-2">
                    Kondition:
                  </v-col>
                  <v-col>
                    <v-progress-linear
                      :value="item.kondition"
                      :color="item.kondition | getStatusColor"
                      height="8"
                    />
                  </v-col>
                  <v-col class="body-2 font-weight-black">
                    {{ item.kondition }}%
                  </v-col>
                </v-row>

                <v-row v-if="newPlayer" align="center" justify="center">
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn
                      :loading="$store.state.loading"
                      :disabled="$store.state.loading"
                      color="primary"
                      dark
                      @click.native="byPlayer(item)"
                      outlined
                    >
                      Spieler für {{ Math.ceil(item.gehalt * $store.state.teamStore.playerBuyMultiplikator) | currency }} kaufen
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>

    <!-- integrate by players -->

    <v-dialog
      v-model="extendDialog"
      persistent
      max-width="310"
    >
      <v-card>
        <v-card-title class="headline">
          Vertrag verlängern
        </v-card-title>
        <v-card-text>Möchtest Du den Vertrag mit <b>{{ newContract.player.name }}</b> um <b>{{ newContract.spieltage }}</b> Tage verlängern? Der Spieler möchte für die neue Spielzeit ein Gehalt von ca. <b>{{ newContract.gehalt | currency }}</b> </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click.native="extendDialog = false"
            :loading="$store.state.loading"
          >
            Abbrechen
          </v-btn>
          <v-btn
            color="success"
            outlined
            @click.native="saveNewPlayerContract"
            :loading="$store.state.loading"
          >
            Verlängern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="310"
    >
      <v-card>
        <v-card-title class="headline">
          Vertrag auflösen
        </v-card-title>
        <v-card-text>Möchtest Du den Vertrag mit <b>{{ deletePlayer.name }}</b> wirklich auflösen? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click.native="abortDelete"
            :loading="$store.state.loading"
          >
            Abbrechen
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click.native="deletePlayerContract"
            :loading="$store.state.loading"
          >
            Auflösen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ROOT_SET_SNACKBAR } from '../store/mutation-types'
// const R = require('ramda')
export default {
  name: 'Players',
  props: {
    players: {
      type: Array,
      default: function () {
        return []
      }
    },
    withContract: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    newPlayer: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data: function () {
    return {
      newContract: {
        spieltage: 30,
        gehalt: 1000,
        player: { name: '' }
      },
      tableView: false,
      search: '',
      icon: 'column',
      extendDialog: false,
      deleteDialog: false,
      deletePlayer: false,
      extendPlayer: false
    }
  },
  computed: {
    headers: function () {
      let headers = [
        {
          text: 'Spieler',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Alter', value: 'alter' },
        { text: 'Gehalt', value: 'gehalt' },
        { text: 'Vertrag läuft noch', value: 'vertrag' },
        { text: 'Position', value: 'position' },
        { text: 'Heimindex (max)', value: 'heimIndex' },
        { text: 'Auswindex (max)', value: 'auswIndex' },
        { text: 'Kraft', value: 'kraft' },
        { text: 'Motivation', value: 'motivation' },
        { text: 'Technik', value: 'technik' },
        { text: 'Kondition', value: 'kondition' }
      ]

      if (this.newPlayer) {
        headers = [
          {
            text: 'Spieler',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Alter', value: 'alter' },
          { text: 'Gehalt', value: 'gehalt' },
          { text: 'Position', value: 'position' },
          { text: 'Heimindex (max)', value: 'heimIndex' },
          { text: 'Auswindex (max)', value: 'auswIndex' },
          { text: 'Kraft', value: 'kraft' },
          { text: 'Motivation', value: 'motivation' },
          { text: 'Technik', value: 'technik' },
          { text: 'Kondition', value: 'kondition' },
          { text: 'Kaufpreis', value: 'kaufpreis' },
          { text: 'Kaufen', value: 'kaufen' }
        ]
      }

      return headers
    }
  },
  methods: {
    byPlayer: async function (player) {
      // check if you have enough money
      if (Math.ceil(player.gehalt * this.$store.state.teamStore.playerBuyMultiplikator) > this.$store.state.moneyStore.giro) {
        this.$store.commit(ROOT_SET_SNACKBAR, 'Achtung, Du hast nicht genug Geld auf deinem Konto, um Dir diesen Spieler zu kaufen. Warte noch ein paar Tage oder verkaufe mehr Würstchen :)')
        return false
      }

      // max players not more then 12 players
      if (this.$store.state.teamStore.players.length < 12) {
        // send player to user data
        if (await this.$store.dispatch('teamStore/addNewPlayer', player)) {
          this.$store.commit(ROOT_SET_SNACKBAR, `Du hast den Spieler ${player.name} gekauft.`)
        }
        return true
      }
      this.$store.commit(ROOT_SET_SNACKBAR, `Achtung, Du hast die maximale Anzahl an Spieler im Kader erreicht.
      Daher kannst Du keine weiteren Spieler kaufen`)
    },
    extendContract: function (player) {
      this.newContract.player = player
      this.newContract.spieltage = 10 + this.$store.state.generateRandomInt(10, 30)
      this.newContract.gehalt = this.getGehalt()
      this.extendDialog = true
    },
    terminateContract: function (player) {
      if (this.$store.state.teamStore.players.length < 7) {
        this.$store.commit(ROOT_SET_SNACKBAR, `Achtung, Du hast nur noch ${this.$store.state.teamStore.players.length} Spieler im Kader. Daher kannst Du keine weiteren Spieler löschen`)
        return false
      }
      this.deletePlayer = player
      this.deleteDialog = true
    },
    deletePlayerContract: async function () {
      // send to database
      if (await this.$store.dispatch('teamStore/deletePlayer', this.deletePlayer)) {
        this.$store.commit(ROOT_SET_SNACKBAR, `Du hast den Vertrag mit ${this.deletePlayer.name} aufgelöst.`)
      }
      this.deleteDialog = false
      this.deletePlayer = false
    },
    abortDelete: function () {
      this.deleteDialog = false
      this.deletePlayer = false
    },
    saveNewPlayerContract: async function () {
      const transferData = {
        playerId: this.newContract.player.id,
        gehalt: this.newContract.gehalt,
        days: this.newContract.spieltage
      }
      if (await this.$store.dispatch('teamStore/extendPlayerContract', transferData)) {
        this.$store.commit(ROOT_SET_SNACKBAR, `Hurra, ${this.newContract.player.name} hat Dein neues Angebot angenommen und den Vertrag unterschrieben.`)
      }
      this.extendDialog = false
      this.newContract = {
        spieltage: 30,
        gehalt: 1000,
        player: { name: '' }
      }
    },
    /*
    * gehalt berechnen
    */
    getGehalt: function () {
      let gehalt = 0
      let heimgehalt = 0
      let auswgehalt = 0
      let j = 0
      let zufall = 0
      const wurfzahl = this.$store.state.teamStore.team.wurfzahl
      const max = this.newContract.spieltage
      const heimindex = this.newContract.player.heimIndex
      const auswindex = this.newContract.player.auswIndex
      if (wurfzahl === 200) {
        // 200 wurf
        // heim
        for (let i = 740; i < 1100; i += 10) {
          if (heimindex >= i && heimindex < i + 10) {
            heimgehalt = j
            break
          }
          zufall = this.$store.state.generateRandomInt(1, max)
          j = j + 5 + zufall
        }
        // ausw
        j = 0
        for (let i = 710; i < 1100; i += 10) {
          if (auswindex >= i && auswindex < i + 10) {
            auswgehalt = j
            break
          }
          zufall = this.$store.state.generateRandomInt(1, max)
          j = j + 5 + zufall
        }
        // get gehalt
        gehalt = Math.ceil((heimgehalt + auswgehalt) / 2)
      } else {
        // 120 wurf
        // heim
        for (let i = 440; i < 740; i += 10) {
          if (heimindex >= i && heimindex < i + 10) {
            heimgehalt = j
            break
          }
          zufall = this.$store.state.generateRandomInt(1, max)
          j = j + 10 + zufall
        }
        // ausw
        j = 0
        for (let i = 410; i < 740; i += 10) {
          if (auswindex >= i && auswindex < i + 10) {
            auswgehalt = j
            break
          }
          zufall = this.$store.state.generateRandomInt(1, max)
          j = j + 10 + zufall
        }
        // get gehalt
        gehalt = Math.ceil((heimgehalt + auswgehalt) / 2)
      }
      return gehalt
    }
  }
}
</script>
